import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis'
})
export class EllipsisPipe implements PipeTransform {

  transform(value: string, ...args: any[]): any {
    const maxLength: number = this.setMaxLength(args[0]);

    if (value == null) {
      return value;
    }

    if (value.length > maxLength) {
      return value.slice(0, maxLength) + '...';
    }

    return value;
  }

  private setMaxLength(arg: any): number {
    switch(arg){
      case 'xl': 
        return 40;
      case 'lg':
        return 27;
      case 'md':
        return 13;
      case 'sm':
        return 5;
      default:
        return arg;
    }
  }
}
